var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtomateLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 23,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M36.463 13.768c0-4.599 4.098-8.448 8.98-8.448 4.88 0 8.979 3.849 8.979 8.448s-4.092 8.48-8.982 8.48-8.977-3.88-8.977-8.48Zm12.953 0c0-2.19-1.815-4.036-3.974-4.036-2.158 0-3.974 1.846-3.974 4.036 0 2.19 1.816 4.068 3.974 4.068 2.159 0 3.974-1.877 3.974-4.068Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M82.13 11.578v10.655h-5.07v-9.716c0-1.627-1.063-2.785-2.566-2.785-1.595 0-2.721 1.095-2.721 2.565v9.936h-5.069v-9.716c0-1.627-1.064-2.785-2.565-2.785-1.596 0-2.723 1.095-2.723 2.565v9.905h-5.287V5.696h5.292v2.095c.782-1.532 2.347-2.47 4.318-2.47 2.159 0 4.036 1.063 5.1 2.784.875-1.69 2.847-2.785 5.225-2.785 3.374 0 6.066 2.597 6.066 6.258Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M99.568 12.266v9.936h-5.1v-1.707c-1.127 1.126-2.815 1.752-4.474 1.752-3.442 0-6.164-2.096-6.164-5.163 0-3.16 3.035-5.38 6.852-5.38 1.3.024 2.583.289 3.786.782v-.22c0-1.72-1.312-2.972-3.536-2.972a6.745 6.745 0 0 0-2.182.353.45.45 0 0 1-.425-.069l-3.119-2.411c2.253-1.128 4.57-1.847 7.072-1.847 4.162 0 7.29 2.629 7.29 6.946Zm-5.1 4.757v-1.721c-.973-.353-2-.533-3.035-.532-1.44 0-2.565.906-2.565 2.158 0 1.252 1 2.065 2.409 2.065 1.565 0 2.972-.744 3.191-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M112.283 20.712c-.97.907-2.565 1.533-3.942 1.533-3.035 0-5.163-2.16-5.163-5.194V9.917h-2.127V6.052l2.127-.12V1.25h5.069v4.563l3.348-.12v4.224h-3.348v6.164c0 1.032.626 1.753 1.471 1.753.596 0 1.192-.22 1.501-.532l1.064 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M35.54 20.712c-.97.907-2.565 1.533-3.935 1.533-3.035 0-5.163-2.16-5.163-5.194V9.917H24.31V6.052l2.127-.12V1.25h5.069v4.563l3.348-.12v4.224h-3.348v6.164c0 1.032.626 1.753 1.47 1.753.597 0 1.193-.22 1.502-.532l1.061 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M11.546 0C5.288 0 0 5.069 0 11.107c0 6.038 5.288 11.14 11.546 11.14 6.289 0 11.576-5.102 11.576-11.14S17.835 0 11.546 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M129.997 14.28c-.299-5.593-3.25-8.96-8.11-8.96-4.882 0-8.448 3.504-8.448 8.417 0 .087 0 .173.006.259.161-.239.332-.46.516-.681a10.235 10.235 0 0 1 1.929-1.79c.771-.54 1.602-.99 2.476-1.339a9.005 9.005 0 0 1 3.379-.63 3.663 3.663 0 0 1 3.459 2.57s-1.739-.11-3.433-.11h-1.823a8.7 8.7 0 0 0-1.455.129 7.247 7.247 0 0 0-3.727 1.916c-.453.434-.842.93-1.156 1.473.776 4.007 4.149 6.713 8.529 6.713 2.409 0 5.194-1.032 6.633-2.504l-3.129-3.164a5.893 5.893 0 0 1-3.661 1.377c-1.721 0-3.004-1.096-3.505-2.723h10.604a.916.916 0 0 0 .916-.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M11.449 17.696a6.703 6.703 0 0 0 6.686-6.7 6.88 6.88 0 0 0-.31-2.027.131.131 0 0 0-.119-.092.53.53 0 0 1-.191-.041 3.653 3.653 0 0 0-1.607-.405.423.423 0 0 1-.41-.534.43.43 0 0 1 .415-.305c.477.004.95.089 1.399.25a.023.023 0 0 0 .026-.03 6.696 6.696 0 0 0-5.882-3.507 6.703 6.703 0 0 0-6.71 6.692v1.211a1.073 1.073 0 0 0 .62.98l.046.018a1.017 1.017 0 0 0 .912-.058.756.756 0 0 0 .239-.176c1.522-1.589 3.02-2.386 4.452-2.386a.418.418 0 0 1 0 .835c-1.14 0-2.352.648-3.642 1.925a.14.14 0 0 0-.04.094 2.734 2.734 0 0 0 .209 1.038c.183.563.466 1.088.835 1.55.187.249.394.482.618.698.486.463 1.025.843 1.69.931.253.029.508.042.764.039Zm-.009-9.264c-.56.011-1.109.15-1.607.405a.422.422 0 0 1-.367-.76 4.453 4.453 0 0 1 1.967-.488.432.432 0 0 1 .418.304.425.425 0 0 1-.41.54Zm3.766 2.733c-.336.201-.695.218-1.021.218h-.042c-.358 0-.728-.008-1.074-.042a.42.42 0 0 1-.388-.446.419.419 0 0 1 .447-.389c.335.025.677.034 1.02.042.24 0 .47-.008.611-.1a.434.434 0 0 1 .586.135.428.428 0 0 1-.138.582h-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.312,
    x2: 125.342,
    y1: 17.113,
    y2: 7.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.174,
    x2: 125.48,
    y1: 19.008,
    y2: 9.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.049,
    x2: 125.605,
    y1: 20.728,
    y2: 11.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.141,
    x2: 125.513,
    y1: 19.462,
    y2: 10.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.545,
    x2: 125.109,
    y1: 13.905,
    y2: 4.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.683,
    x2: 124.971,
    y1: 12.013,
    y2: 2.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.09,
    x2: 125.744,
    y1: 22.655,
    y2: 13.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB472"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h130v22.246H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtomateLogo);
export default __webpack_public_path__ + "static/media/otomate-logo.ff1bab358a66478584529f100c200fa4.svg";
export { ForwardRef as ReactComponent };